import { AnimatePresence, m } from "framer-motion";

interface MobileMenuButtonProps {
	isOpen: boolean;
	onToggle: () => void;
}

export function MobileMenuButton({ isOpen, onToggle }: MobileMenuButtonProps) {
	return (
		<button
			type="button"
			onClick={onToggle}
			className="lg:hidden flex items-center justify-center w-9 h-9 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0072f5]/60"
			style={{ color: "#888888" }}
			onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = "#ffffff"; (e.currentTarget as HTMLElement).style.backgroundColor = "#201f1f"; }}
			onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = "#adaaaa"; (e.currentTarget as HTMLElement).style.backgroundColor = "transparent"; }}
			onFocus={e => { (e.currentTarget as HTMLElement).style.color = "#ffffff"; (e.currentTarget as HTMLElement).style.backgroundColor = "#201f1f"; }}
			onBlur={e => { (e.currentTarget as HTMLElement).style.color = "#adaaaa"; (e.currentTarget as HTMLElement).style.backgroundColor = "transparent"; }}
			aria-label={isOpen ? "Close menu" : "Open menu"}
			aria-expanded={isOpen}
		>
			<AnimatePresence mode="wait">
				{isOpen ? (
					<m.div
						key="close"
						initial={{ rotate: -90, opacity: 0 }}
						animate={{ rotate: 0, opacity: 1 }}
						exit={{ rotate: 90, opacity: 0 }}
						transition={{ duration: 0.2 }}
					>
						<span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px" }}>close</span>
					</m.div>
				) : (
					<m.div
						key="menu"
						initial={{ rotate: 90, opacity: 0 }}
						animate={{ rotate: 0, opacity: 1 }}
						exit={{ rotate: -90, opacity: 0 }}
						transition={{ duration: 0.2 }}
					>
						<span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "20px" }}>menu</span>
					</m.div>
				)}
			</AnimatePresence>
		</button>
	);
}
